import {
  CampaignDateFields,
  CampaignDescriptionField,
  CampaignNameField,
} from './CreateCampaignFields';

export const CreateMemberCampaignForm = () => {
  return (
    <>
      <CampaignNameField />
      <CampaignDescriptionField />
      <CampaignDateFields />
    </>
  );
};
